import ErrorHandler from './ErrorHandler';

export function fetchAvailableDays(productId, amount, locationIds) {
  return fetch(`/api/products/${productId}/available-days?locations=${locationIds}&amount=${amount}`, { method: 'GET' })
    .then(ErrorHandler)
    .then((response) => response.json());
}
